<template>
  <div style="width: 100%; height: 100%">
    <div id="pie2"></div>
    <div id="zongzichan">
      <span>总资产</span><b>{{ all }}台</b>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";

export default {
  data() {
    return {
      myData: [
        { value: 12, name: "巡查车" },
        { value: 6, name: "扫地车" },
        { value: 8, name: "小轿车" },
        { value: 14, name: "其他车" },
      ],
      all: 0,
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 50,
        sort: 2,
        startTime: "",
      },
    };
  },
  methods: {
    groups(v) {
      this.searchItem.groupIdList = [];
      for (let i = 0; i < v.length; i++) {
        this.searchItem.groupIdList.push(v[i].id);
      }
      this.getData();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/data/countCarType",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;

        data = data.sort(function up(x, y) {
          return y.carNum - x.carNum;
        });
        this.myData = [];
        var limit = 7;
        var last = 0;
        for (let i = 0; i < data.length; i++) {
          this.all += Number(data[i].carNum);
          if (i < limit - 1) {
            var obj = {
              value: data[i].carNum,
              name: data[i].carTypeName + ' ' + data[i].carNum,
            };
            this.myData.push(obj);
          } else {
            last +=Number(data[i].carNum);
            if (i == data.length - 1) {
              var obj = {
                value: last,
                name: '更多车型' + ' ' + last
              };
              this.myData.push(obj);
            }
          }

        }
        this.drawBar("pie2");
      });
    },
    drawBar(id) {
      var that = this;
      this.chart = echarts.init(document.getElementById(id), "dark");
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
          formatter: "{b}: ({d}%)",
        },
        legend: {
          // orient: "vertical",
          //图例组件
          left: 0, //图例组件离右边的距离
          orient: "vertical", //布局  纵向布局
          //width: 40, //图行例组件的宽度,默认自适应
          x: "left", //图例显示在右边
          itemWidth: 12, //图例标记的图形宽度
          itemHeight: 12, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 14,
          },
          //data: ["日常费用", "保养费", "维修费", "加油费"]
        },
        series: [
          {
            name: "",
            type: 'pie',
            radius: ["20%", "60%"],
            avoidLabelOverlap: false,
            //roseType: "area",
            label: {
              show: false,
              position: "left",
            },
            labelLine: {
              show: false,
            },
            data: this.myData,
          },
        ],
        color: [
          "#5d97f7",
          "#06f9aa",
          "#f9c539",
          "#fa3699",
          "#64bff8",
          "#2acc4d",
          "#e860ad",
          "#e8bd60",
        ],
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  mounted() {
    // this.drawBar("pie2");
    this.getData();
  },
};
</script>
<style lang="">
#pie2 {
  width: 100%;
  height: calc(100% - 70px);
}
#zongzichan {
  font-size: 20px;
}
#zongzichan span {
  margin-right: 10px;
  background: #0856a5;
  border-radius: 20px;
  padding: 4px 10px;
  color: #9bdaee;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/diaodu/pie.vue